module.exports = __webpack_public_path__ + "static/img/home-hot5.2d1d1eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-hot5.png
// module id = 9oMh
// module chunks = 21